export const UPDATE_SHOP = 'UPDATE_SHOP';
export const GET_SHOP = 'GET_SHOP';
export const ADD_SHOP_PHOTO = 'ADD_SHOP_PHOTO';
export const UPLOAD_SHOP_LOGO = 'UPLOAD_SHOP_LOGO';
export const SHOP_FETCH_SUBSCRIPTION = 'SHOP_FETCH_SUBSCRIPTION';
export const GET_SHOPS = 'GET_SHOPS';

export const SHOP_TYPE = {
  rental: 0, // independent barbers
  commission: 1, // single owner
};

export const SHOP_CURRENCY = {
  usd: 'usd',
  cad: 'cad',
  gbp: 'gbp',
  aud: 'aud',
  eur: 'eur',
};

export const COUNTRY_CODE_BY_CURRENCY = {
  [SHOP_CURRENCY.usd]: 'US',
  [SHOP_CURRENCY.cad]: 'CA',
  [SHOP_CURRENCY.gbp]: 'GB',
  [SHOP_CURRENCY.aud]: 'AU',
  [SHOP_CURRENCY.eur]: 'IE',
};

export const COUNTRY_NAME_BY_CODE = {
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  IE: 'Ireland',
  AU: 'Australia',
};

export const brandSupportedLanguagesOption = {
  value: 'brandSupportedLanguages',
  label: 'Use brand supported languages',
  isExclusive: true,
};

export const DEFAULT_COMMISSION_SPLIT_FEE_PERCENT = 2;
export const DEFAULT_AUTO_TIPS_FEE_PERCENT = 2;
